<template>
  <div>

    <form class="evollu-form">
      <!-- Block Detail -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.block_detail') }}
        </h5>


        <div class="row col-12" style="margin-bottom: 0px !important;">
          <!-- input name -->
          <div class="col-6 col-md-6">
            <va-input
              id="name"
              v-model="value.name"
              :label="$t('iframe.blocks_builder.block_name')"
              :placeholder="$t('iframe.blocks_builder.block_name')"
              @input="formErrors.clear('name')"
            />

            <small v-show="formErrors.has('name')" class="help text-danger">
              {{ $t(formErrors.get('name')) }}
            </small>
          </div>
          <!-- --- --->

          <!-- input lang -->
          <div class="row col-md-6">
            <div class="col-12">
              <label class="form-label">{{ $t('iframe.table_headings.lang') }}</label>
              <multiselect
                :options="langOptions"
                id="lang"
                v-model="value.lang"
                :custom-label="opt => opt.language_key ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}` : 'N/A'"
                track-by="lang"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                open-direction="bottom"
                :allow-empty="false"
                :multiple="false"
                :searchable="true"
                @input="formErrors.clear('lang')"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>

              <small v-show="formErrors.has('lang')" class="help text-danger">
                {{ $t(formErrors.get('lang')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

        <div class="row col-12">
          <div class="row col-md-6 ml-0">
            <div class="col-12 p-0">
              <label class="form-label">{{ $t('iframe.table_headings.client') }}</label>
              <multiselect
                :options="clientOptions"
                id="client"
                v-model="client"
                label="name"
                track-by="name"
                :disabled="clientOptions.length === 1"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                open-direction="bottom"
                :allow-empty="false"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>

          </div>

          <!-- Show consent options? --->
          <div class="col-6 col-md-6 mt-4">
          <span class="select is-fullwidth is-small">
                <va-checkbox
                  :label="$t('iframe.blocks_builder.contact_block.show_consent_options')"
                  id="checkbox-show-consent-options"
                  :isCircle="true"
                  v-model="value.consent_options"/>
              </span>
          </div>
          <!--- --- --->
        </div>

      </div>

      <!-- Titles Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.title_section') }}
        </h5>

        <div class="row col-12 mb-2">
          <!-- input titulo -->
          <div class="col-6 col-md-6">
            <va-input
              id="title"
              v-model="value.title"
              :label="$t('iframe.titles.title')"
              :placeholder="$t('iframe.titles.title')"
              @input="formErrors.clear('title')"
            />

            <small v-show="formErrors.has('title')" class="help text-danger">
              {{ $t(formErrors.get('title')) }}
            </small>
          </div>
          <!-- --- --->

          <!-- input subtitulo -->
          <div class="col-6 col-md-6">
            <va-input
              id="subtitle"
              type="textarea"
              :min-rows="2"
              v-model="value.subtitle"
              :label="$t('iframe.titles.sub_subtitle')"
              :placeholder="$t('iframe.titles.sub_subtitle')"
              @input="formErrors.clear('subtitle')"
            />

            <small v-show="formErrors.has('subtitle')" class="help text-danger">
              {{ $t(formErrors.get('subtitle')) }}
            </small>
          </div>
        </div>
        <!-- --- --->


      </div>
      <!------------>


      <!--Override Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.override_section.title') }}
        </h5>

        <div class="row col-12">
          <div class="col-6 col-md-6">
            <va-input
              id="overrideBtnPreviousTitle"
              type="text"
              v-model="value.override_button_previous_title"
              :label="$t('iframe.blocks_builder.override_section.previous_button_title')"
              :placeholder="$t('iframe.blocks_builder.override_section.previous_button_title')"
              @input="formErrors.clear('override_button_previous_title')"
            />

            <small v-show="formErrors.has('subtitle')" class="help text-danger">
              {{ $t(formErrors.get('override_button_previous_title')) }}
            </small>
          </div>

          <div class="col-6 col-md-6">
            <va-input
              id="overrideBtnPreviousAction"
              type="text"
              v-model="value.override_button_previous_action"
              :label="$t('iframe.blocks_builder.override_section.previous_button_action')"
              :placeholder="$t('iframe.blocks_builder.override_section.previous_button_action')"
              @input="formErrors.clear('override_button_previous_action')"
            />

            <small v-show="formErrors.has('subtitle')" class="help text-danger">
              {{ $t(formErrors.get('override_button_previous_action')) }}
            </small>
          </div>
        </div>
      </div>
      <!-- ------------------>


      <!--- Form items Section ---->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.contact_block.form_items_section') }}
        </h5>

        <!--Header-->
        <div class="row col-12">
          <div class="col-md-2">
            <label class="header-lbl">{{ $t('iframe.pages_configurator.headings.order') }}</label>
          </div>
          <div class="col-md-3">
            <label class="header-lbl">{{ $t('iframe.blocks_builder.contact_block.option') }}</label>
          </div>
          <div class="col-md-3">
            <label class="header-lbl">{{ $t('iframe.blocks_builder.contact_block.placeholder') }}</label>
          </div>
          <div class="col-md-2 w-100 d-flex justify-content-center">
            <label class="header-lbl">{{ $t('iframe.pages_configurator.headings.mandatory') }}</label>
          </div>
          <div class="col-md-2 w-100 d-flex justify-content-center">
            <label class="header-lbl">{{ $t('iframe.pages_configurator.headings.actions') }}</label>
          </div>
        </div>
        <!--End Header-->
        <div class="col-12" id="formItemsContainer">
          <!-- Items Area -->
          <div class="row col-12 custom-border-outline justify-content-center align-content-center" style="height: 60px"
               v-if="addedItems.length===0">
            <label class="placeholder-label">{{ $t('iframe.blocks_builder.contact_block.no_form_items') }}</label>
          </div>
          <div v-else>
            <div class="row col-12 mt-2 custom-border-outline align-content-center" style="height: 80px"
                 v-for="(item, idx) of addedItems">
              <div class="col-md-2 d-flex flex-column">
                <i class="fa fa-caret-up" v-bind:class="{'clickable': idx !== 0, 'sort-icon-disabled': idx === 0}"
                   @click="idx !== 0 ? handleSort('up', item) : null"/>
                <i class="fa fa-caret-down"
                   v-bind:class="{'clickable': idx !== addedItems.length-1, 'sort-icon-disabled': idx === addedItems.length-1}"
                   @click=" idx !== addedItems.length-1 ? handleSort('down', item) : null"/>
              </div>
              <div class="custom-multiselect col-md-3">
                <multiselect
                  :options="formInputNames"
                  id="formInputSelector"
                  v-model="item.name"
                  label="name"
                  track-by="id"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  placeholder="---"
                  open-direction="bottom"
                  :allow-empty="false"
                  :multiple="false"
                  :searchable="true"
                >
                  <span slot="noResult">{{ $t('patients.noResults') }}</span>
                </multiselect>
              </div>

              <div class="custom-multiselect col-md-3">
                <va-input
                  :disabled="!item.name"
                  id="formInputPlaceholder"
                  v-model="item.item.placeholder"
                  :placeholder="$t('iframe.blocks_builder.contact_block.placeholder')"
                />
              </div>

              <div class=" col-md-2 w-100 d-flex justify-content-center">
                <span class="round">
                  <input class="mandatory" type="checkbox" :id="'checkboxMandatory_' + idx" :checked="item.item.mandatory" @click="item.item.mandatory = !item.item.mandatory">
                  <label class="mandatory" :for="'checkboxMandatory_' + idx"></label>
                </span>
              </div>

              <div class="col-md-2 w-100 d-flex justify-content-center">
                <va-popover :message="$t('iframe.actions.delete')" placement="top">
                  <i class="report-action-icon fa fa-trash-o p-2 clickable" @click.prevent.stop="removeItem(item)"/>
                </va-popover>
              </div>
            </div>
          </div>
          <!---------------->
        </div>

        <!-- Add new pages -->
        <div class="row col-12 mt-3 mb-4" v-if="addedItems.length < 4">
          <div class="col-12 mb-2">
            <label class="font-weight-bold">{{ $t('iframe.blocks_builder.contact_block.add_new_item') }}</label>
          </div>
          <div class=" col-md-2" style="padding-left: 40px">
            ---
          </div>
          <div class=" custom-multiselect col-md-3">
            <multiselect
              :options="formInputNames"
              id="addFormInputSelector"
              v-model="itemToAdd.name"
              label="name"
              track-by="id"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>
          </div>
          <div class=" custom-multiselect col-md-3">
            <va-input
              :disabled="!itemToAdd.name"
              id="addFormInputPlaceholder"
              v-model="itemToAdd.placeholder"
              :placeholder="$t('iframe.blocks_builder.contact_block.placeholder')"
            />
          </div>
          <div class=" col-md-2 w-100 d-flex justify-content-center">
            <span class="round">
            <input class="mandatory" type="checkbox" id="checkboxMandatorySelect" :checked="itemToAdd.mandatory" @click="itemToAdd.mandatory = !itemToAdd.mandatory">
            <label class="mandatory" for="checkboxMandatorySelect"></label>
          </span>
          </div>
          <div class=" col-md-2 w-100 d-flex justify-content-center">
            <div class="btn btn__round btn_add">
              <va-button
                :disabled="!itemToAdd.placeholder || itemToAdd.placeholder.length < 1"
                @click.prevent="onClickAddItem">
                <i class="fa fa-plus"></i>
              </va-button>
            </div>
          </div>
        </div>

      </div>
      <!-------------------->

    </form>
  </div>
</template>

<script>
import Errors from "@/utils/StandardErrors";
import Multiselect from 'vue-multiselect'
import {mapState} from "vuex";

export default {
  components: {Multiselect},
  props: {
    value: {
      type: Object,
      required: false
    },
    clientOptions: {
      type: Array,
      required: true,
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data() {
    return {
      langOptions: this.$store.state.languages,
      itemToAdd: {
        name: null,
        placeholder: null,
        mandatory: false
      },
      addedItems: [],
      client: null
    }
  },
  mounted() {
    for (const [index, item] of this.value.fields.entries()) {
      this.addedItems.push({
        order: index,
        name: this.formInputNames.filter(elem => elem.name === item.name)[0],
        item: item
      })
    }
    if(this.value && this.value.client_id) {
      this.value.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
      this.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
    }
  },
  methods: {
    getAddedItems: function () {

      let items = this.addedItems.map(it => it.item)
      for(let item of items) {
        item.name = item.name.name
        if(item.id) {
          item.id = parseInt(item.id)
        }
      }
      return items
    },
    removeItem: function (formItem) {
      this.addedItems.splice(this.addedItems.findIndex(item => item.id === formItem.id && item.order === formItem.order), 1)
    },
    onClickAddItem: function () {
      if (this.itemToAdd.name !== null && this.itemToAdd.placeholder !== null) {
        let lastIdx = this.addedItems.length
        this.addedItems.push({
          order: lastIdx,
          name: this.itemToAdd.name,
          item: {
            name: this.itemToAdd.name,
            placeholder: this.itemToAdd.placeholder,
            mandatory: this.itemToAdd.mandatory,
            lang: this.value.lang.lang || null
          }
        })

        this.itemToAdd = {
          name: null,
          placeholder: null,
          mandatory: false
        }
      }
    },
    handleSort: function (direction, formItem) {
      const currentElemIdx = this.addedItems.findIndex(item => item.id === formItem.id && item.order === formItem.order)
      const currentElemOrderTemp = formItem.order

      if (direction === 'down') {
        const nextElemOrderTemp = this.addedItems[currentElemIdx + 1].order
        //update the current element to have the orderNr of the next one
        this.addedItems[currentElemIdx].order = nextElemOrderTemp
        //update the next element to have the orderNr of the current one
        this.addedItems[currentElemIdx + 1].order = currentElemOrderTemp

        //sort the array by order
        this.addedItems = this.addedItems.sort((a, b) => (a.order > b.order) ? 1 : -1)
      } else if (direction === 'up') {
        const lastElemOrderTemp = this.addedItems[currentElemIdx - 1].order
        //update the current element to have the orderNr of the next one
        this.addedItems[currentElemIdx].order = lastElemOrderTemp
        //update the next element to have the orderNr of the current one
        this.addedItems[currentElemIdx - 1].order = currentElemOrderTemp

        //sort the array by order
        this.addedItems = this.addedItems.sort((a, b) => (a.order > b.order) ? 1 : -1)
      }
    }
  },
  computed: {
    ...mapState({
      'formInputNames': (state) => state.iframe.formInputNames,
    }),
  },
  watch: {
    'value.override_button_previous_action': function (val) {
      if (val === '') {
        this.value.override_button_previous_action = null
      }
    },
    'value.override_button_previous_title': function (val) {
      if (val === '') {
        this.value.override_button_previous_title = null
      }
    },
    client: function (val) {
      if (val) {
        this.value.client = val
      }
    }
  }

}
</script>

<style scoped>
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}


.btn_add {
  padding: 0 !important;
}

.custom-border-outline {
  border: 2px solid rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}

.custom-multiselect {
  padding-left: 0 !important;
  padding-right: 45px !important;
}

.placeholder-label {
  color: rgba(194, 194, 194, 0.55)
}

.sort-icon-disabled {
  opacity: 0.2;
}
</style>

<style lang="scss">
@import "~vuestic-ui/src/components/vuestic-sass/vuestic-styles";

.header-lbl {
  padding-left: 5px;
  color: $evollu-dark;
}
</style>
